import React, { useState, useEffect } from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultsRSC, getUnits, getResultsPhase } from "data/Querys"
import Loader from 'components/general/Loader'
import { getPhaseRSC, getLongPhaseRSC } from 'helpers/rsc'
import ProgressionRule from 'components/common/ProgressionRule'
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Label from "components/general/Label"
import NotAvailable from 'components/common/NotAvailable'
//Results
import SwmResults from 'components/sports/swm/views/SwmResults'
import SwmSumResults from 'components/sports/swm/views/SwmSumResults'
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { isPhaseFinal } from 'components/sports/swm/helper/SwmHelpers'
import { useEventUnit } from "components/common/EventUnit";
import RecordsPrototype from "components/general/RecordsPrototype";


const SwmContext = () => {
    const eu = useEventUnit()
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    const [key, setKey] = useState('results');


    let isRR = false;
    let rsc = mirs_rsc;


    //RSC es una phase swim-off
    if (rsc.endsWith('RR--------')) {
        rsc = rsc.substring(0, rsc.length - 10) + "NL"
        isRR = true;
    } else if (rsc.endsWith('RR--')) { //unit swim-off
        isRR = true;
    }

    let _phase = getPhaseRSC(rsc);
    let _longPhase = getLongPhaseRSC(rsc);
    const isFinal = isPhaseFinal(rsc);



    //DATA
    const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
        {
            queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase],
            queryFn: getUnits,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );

    let queryArray = [];


    let units;

    // swim-off units 

    if (isRR) {
        units = unitsData?.phase?.units?.filter(item => item?.code.endsWith('RR--'))
    } else {
        //remove swim-off in normal phases 
        units = unitsData?.phase?.units?.filter(item => !item?.code.endsWith('RR--'))

    }

    units?.forEach((unit) => {
        queryArray.push({
            queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, _longPhase],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });


    const { data: phaseResult, isError: phaseResultError, isLoading: phaseResultLoading } = useQuery(
        {
            queryKey: ['resultsPhaseSummary', mirs_competition, getPhaseRSC(mirs_rsc), mirs_language],
            queryFn: getResultsPhase,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        });



    //DATA
    const { data, isErrorData, isLoadingData } = useQuery(
        {
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language, _longPhase],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        });

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const results = useQueries(queryArray);
    const isLoading = unitsLoading || phaseResultLoading || isLoadingData || results.some(result => result.isLoading)
    const isError = unitsError || phaseResultError || isErrorData || results.some(result => result.isError)

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }


    let tabTitle = !isFinal ? "Heats" : "HeaderResults";

    const dataHeader = eu(mirs_rsc, false)
    //const dataHeader = unitsData?.phase?.units?.find(item => item.code === mirs_rsc)

    let unitsFound = 0
    return (
        <>
            <PageHeader title={dataHeader} />
            <div className='mirs-page-container'>
            {data?.records && <RecordsPrototype records={data.records} hasTableExpanded={true} config={data.config} />}
            <Tabs
                id="mirs-navsport"
                className="mb-3 mirs-tab-result"
                defaultActiveKey={`1-${mirs_rsc}`}
                onSelect={(k) => setKey(k)}
            >

                <Tab eventKey={`1-${mirs_rsc}`} title={<Label data={tabTitle} />} >
                    {(_phase.indexOf("HEAT") > -1)
                        ?
                        <ProgressionRule
                            key="progress-component"
                            data={results[0]?.data?.config}
                            filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
                        />
                        : ''
                    }
                    {results.map((res, index) => {
                        if (res.data?.results?.items !== undefined)
                            unitsFound++
                        return <SwmResults key={`results-component-${index}`} data={res.data} />
                    })
                    }
                </Tab>

                {(!isFinal) &&
                    <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="LabelSummary" />}  >
                        {phaseResult?.phaseResults && <SwmSumResults data={phaseResult?.phaseResults[0]} />}
                    </Tab>
                }
            </Tabs>
            </div>
        </>
    );
};
export default SwmContext;
